import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How is this different from a traditional pentest?',
      answer: 'A pentest costs $50K, takes 3 weeks, and gives you a PDF that\'s outdated before you read it. We run on every build, cost a fraction, and give you video proof of every exploit. It\'s not a comparison. It\'s a replacement.',
    },
    {
      question: 'What vulnerabilities can you find?',
      answer: 'The ones that actually get you breached. IDOR, broken access control, privilege escalation, session hijacking, data exposure, deep link exploitation. The business logic flaws that scanners are fundamentally incapable of finding because they require reasoning, not pattern matching.',
    },
    {
      question: 'How does the AI reasoning work?',
      answer: 'It thinks like a hacker, not a scanner. It maps your app, understands your authorization model, then asks dangerous questions: "What if User A requests User B\'s data?" Then it actually tries it. Multi-step attacks, chained exploits, real exploitation. Not theoretical risk scores.',
    },
    {
      question: 'Can this integrate with our CI/CD pipeline?',
      answer: 'It was built for it. Security becomes a gate in your pipeline, just like tests. Green means ship. Red means fix. No more shipping blind and hoping for the best.',
    },
    {
      question: 'What platforms do you support?',
      answer: 'Android today. iOS is coming. Every test runs on real physical devices in our cloud — not emulators, not simulators. Real hardware. Real results.',
    },
    {
      question: 'How fast can we get started?',
      answer: 'Upload your APK. That\'s it. No scripts. No configuration. No onboarding calls. Our AI starts finding vulnerabilities in minutes. Most teams see critical findings in their first session.',
    },
  ];

  return (
    <section className="relative">
      <div className="section-divider"></div>

      <div className="container mx-auto px-6 py-28">
        <div className="max-w-3xl mx-auto">
          {/* Section header */}
          <div className="mb-16">
            <div className="tag mb-8">
              <span className="w-[6px] h-[6px] rounded-full bg-[#00ffd5] shadow-[0_0_8px_#00ffd5]"></span>
              FAQ
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
              You're Skeptical.
              <br />
              <span className="text-white/30">Good.</span>
            </h2>
          </div>

          <div className="space-y-2">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="card-tactical rounded-sm overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-white/[0.01] transition-all"
                >
                  <span className="font-medium text-white/80 pr-4 text-[0.95rem]" style={{ fontFamily: 'var(--font-body)' }}>
                    {faq.question}
                  </span>
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 border border-white/[0.06]">
                    {openIndex === index ? (
                      <Minus className="w-3.5 h-3.5 text-[#00ffd5]" />
                    ) : (
                      <Plus className="w-3.5 h-3.5 text-white/40" />
                    )}
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5 text-white/30 text-sm leading-relaxed border-t border-white/[0.03] pt-4" style={{ fontFamily: 'var(--font-body)' }}>
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
